import type { AnalyticsWindow } from './schemas';

function scopedAddress(address: string | undefined): string | undefined {
  return address?.toLowerCase();
}

export const investorAnalyticsKeys = {
  all: ['investor-analytics'] as const,
  risk: (
    address: string | undefined,
    chainId: number,
    window: AnalyticsWindow
  ) =>
    [
      ...investorAnalyticsKeys.all,
      'risk',
      scopedAddress(address),
      chainId,
      window
    ] as const,
  liquidity: (address: string | undefined, chainId: number) =>
    [
      ...investorAnalyticsKeys.all,
      'liquidity',
      scopedAddress(address),
      chainId
    ] as const
};
